module.exports = __webpack_public_path__ + "static/location-info8-10f3b0c6757ad0b7bb1a2df271184721.jpg";